























































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { citasHubService } from "@/shared/services/CitasHubService";

@Component({ name: "CitasEditWizardTest" })
export default class CitasEditWizardTest extends Vue {
  public step = 1;
  public cargando = false;
  public cargandoSlots = false;
  public ejecutando = false;

  // Datos citas
  public todasLasCitas: any[] = [];
  public catalogos: any = { centros: [], estados: [] };

  // Filtros paso 1
  public busqueda = "";
  public filtroCentro: number | null = null;
  public filtroEstado: string | null = null;

  // Selecciones
  public citaSeleccionada: any = null;
  public accionCliente: "reagendar" | "cancelar" | "" = "";

  // Reagendar
  public nuevaFecha = "";
  public huecos: any[] = [];
  public nuevoSlot: any = null;

  // Cancelar
  public motivoCancelacion = "";

  // Resultado
  public resultadoOk = false;
  public resultadoRaw: any = null;
  public duracionMs = 0;
  public estadoAntes = "";
  public citaGesdenAntes = false;
  public citaActualizada: any = null;

  get hoy(): string {
    const d = new Date();
    return d.toISOString().split("T")[0];
  }

  get pasosActivos(): string[] {
    if (this.accionCliente === "cancelar") {
      return ["Seleccionar cita", "Qué quiere hacer", "Confirmar cancelación", "Resumen", "Resultado"];
    }
    return ["Seleccionar cita", "Qué quiere hacer", "Nuevo hueco", "Resumen", "Resultado"];
  }

  get centrosSelect() {
    return (this.catalogos.centros || []).map((c: any) => ({ text: c.nombre, value: c.id }));
  }

  get estadosFiltroSelect() {
    return [
      { text: "Pendiente", value: "pendiente" },
      { text: "Confirmada", value: "confirmada" },
      { text: "En revisión", value: "en_revision" },
      { text: "Enviada Gesden", value: "enviada_gesden" },
      { text: "Insertada en Gesden", value: "insertada_gesden" },
      { text: "⚠ Cancelación pendiente Gesden", value: "cancelacion_pendiente_gesden" },
      { text: "⚠ Reagendado pendiente Gesden", value: "reagendado_pendiente_gesden" },
    ];
  }

  get citasFiltradas() {
    let rows = this.todasLasCitas.filter((r) =>
      ["pendiente", "confirmada", "en_revision", "enviada_gesden",
       "insertada_gesden", "cancelacion_pendiente_gesden", "reagendado_pendiente_gesden"].includes(r.estado_codigo)
    );
    if (this.filtroCentro) { rows = rows.filter((r) => r.id_centro === this.filtroCentro); }
    if (this.filtroEstado) { rows = rows.filter((r) => r.estado_codigo === this.filtroEstado); }
    return rows;
  }

  public headersTabla = [
    { text: "Paciente", value: "paciente_nombre", sortable: true },
    { text: "Centro", value: "centro_nombre", sortable: true },
    { text: "Servicio", value: "servicio_nombre", sortable: true },
    { text: "Doctor", value: "nombre_profesional", sortable: true },
    { text: "Fecha", value: "fecha_hora_inicio_solicitada", sortable: true },
    { text: "Estado", value: "estado_codigo", sortable: true },
    { text: "Gesden", value: "gesden", sortable: false, align: "center" },
    { text: "", value: "seleccionar", sortable: false, align: "center" },
  ];

  public async mounted() {
    const today = new Date();
    this.nuevaFecha = today.toISOString().split("T")[0];
    await Promise.all([this.cargarCatalogos(), this.cargarCitas()]);
  }

  public async cargarCatalogos() {
    try {
      const res = await ssmHttpService.get(`${API.solicitudesWorkflow}/admin/catalogos`, null, false);
      const data = res && res.data ? res.data : res;
      if (data && data.centros) { this.catalogos = data; }
    } catch (e) { /* silencioso */ }
  }

  public async cargarCitas() {
    this.cargando = true;
    try {
      const res = await ssmHttpService.get(`${API.solicitudesWorkflow}/admin/tablero`, null, false);
      const rows = (res && res.data ? res.data.rows : res && res.rows ? res.rows : []) || [];
      this.todasLasCitas = rows.map((r: any) => ({
        ...r,
        necesita_accion: ["cancelacion_pendiente_gesden", "reagendado_pendiente_gesden"].includes(r.estado_codigo),
      }));
    } catch (e) { /* silencioso */ } finally {
      this.cargando = false;
    }
  }

  public seleccionarCita(item: any) {
    this.citaSeleccionada = item;
  }

  public rowClass(item: any): string {
    return this.citaSeleccionada && this.citaSeleccionada.id === item.id ? "row-selected" : "";
  }

  public irAPaso3() {
    this.nuevoSlot = null;
    this.huecos = [];
    if (this.accionCliente === "reagendar") {
      this.cargarHuecos();
    }
    this.step = 3;
  }

  public async onNuevaFechaChanged() {
    this.nuevoSlot = null;
    this.huecos = [];
    await this.cargarHuecos();
  }

  public async cargarHuecos() {
    if (!this.citaSeleccionada || !this.nuevaFecha) { return; }
    this.cargandoSlots = true;
    try {
      const centroId = this.citaSeleccionada.id_centro;
      const codigoServicio = this.citaSeleccionada.codigo_servicio || this.citaSeleccionada.servicio_codigo;
      if (!centroId || !codigoServicio) {
        this.huecos = [];
        return;
      }
      const from = this.nuevaFecha + "T00:00:00";
      const to = this.nuevaFecha + "T23:59:59";
      const params = "from=" + encodeURIComponent(from) + "&to=" + encodeURIComponent(to) + "&limit=50&waitSeconds=20";
      const url = API.publicAgenda + "/centros/" + centroId + "/servicios/" + encodeURIComponent(codigoServicio) + "/huecos?" + params;
      const res = await ssmHttpService.get(url, null, false);
      const rows = res && Array.isArray(res.rows) ? res.rows : [];
      this.huecos = rows.sort((a: any, b: any) =>
        new Date(a.fecha_hora_inicio_local).getTime() - new Date(b.fecha_hora_inicio_local).getTime()
      );
    } catch (e) {
      this.huecos = [];
    } finally {
      this.cargandoSlots = false;
    }
  }

  public async ejecutar() {
    if (!this.citaSeleccionada) { return; }

    this.estadoAntes = this.citaSeleccionada.estado_codigo;
    this.citaGesdenAntes = !!this.citaSeleccionada.fecha_insercion_gesden;
    this.ejecutando = true;
    const t0 = Date.now();

    try {
      if (this.accionCliente === "cancelar") {
        await this.ejecutarCancelacion();
      } else {
        await this.ejecutarReagendado();
      }
    } finally {
      this.ejecutando = false;
      this.duracionMs = Date.now() - t0;
    }

    // Recargar para ver estado actualizado
    try {
      await this.cargarCitas();
      this.citaActualizada = this.todasLasCitas.find((r) => r.id === this.citaSeleccionada.id) || null;
    } catch (e) {
      this.citaActualizada = null;
    }

    this.step = 5;
  }

  private async ejecutarCancelacion() {
    try {
      const payload: any = {
        uuid: this.citaSeleccionada.uuid,
        telefono: this.citaSeleccionada.paciente_telefono || null,
        email: this.citaSeleccionada.paciente_email || null,
        documento: this.citaSeleccionada.paciente_documento || null,
        comentario: this.motivoCancelacion || null,
      };
      const res = await ssmHttpService.post(
        API.solicitudesWorkflow + "/public/cancelar",
        payload,
        false,
        false,
        false,
        citasHubService.getConnectionHeader()
      );
      this.resultadoOk = !!(res && (res.success || res.data || res.id));
      this.resultadoRaw = res;
    } catch (e) {
      const err = e as any;
      this.resultadoOk = false;
      this.resultadoRaw = (err && err.response && err.response.data) || (err && err.message) || err;
    }
  }

  private async ejecutarReagendado() {
    if (!this.nuevoSlot) { return; }
    try {
      const nuevaFechaHora =
        this.nuevoSlot.fecha_hora_inicio_local ||
        this.nuevoSlot.fecha_hora_inicio_solicitada;
      if (!nuevaFechaHora) { throw new Error("No se pudo resolver la nueva fecha/hora"); }

      const doctorId =
        this.nuevoSlot.ID_Agenda ||
        this.nuevoSlot.id_profesional_externo ||
        null;

      const payload: any = {
        uuid: this.citaSeleccionada.uuid,
        nueva_fecha_hora_inicio: nuevaFechaHora,
        id_profesional_externo: doctorId,
        telefono: this.citaSeleccionada.paciente_telefono || null,
        email: this.citaSeleccionada.paciente_email || null,
        documento: this.citaSeleccionada.paciente_documento || null,
        comentario: "Reprogramada desde CitasEditWizardTest",
      };
      const res = await ssmHttpService.post(
        API.solicitudesWorkflow + "/public/reprogramar",
        payload,
        false,
        false,
        false,
        citasHubService.getConnectionHeader()
      );
      this.resultadoOk = true;
      this.resultadoRaw = res;
    } catch (e) {
      const err = e as any;
      this.resultadoOk = false;
      this.resultadoRaw = (err && err.response && err.response.data) || (err && err.message) || err;
    }
  }

  public reiniciar() {
    this.step = 1;
    this.citaSeleccionada = null;
    this.accionCliente = "";
    this.nuevoSlot = null;
    this.huecos = [];
    this.motivoCancelacion = "";
    this.resultadoOk = false;
    this.resultadoRaw = null;
    this.citaActualizada = null;
  }

  public colorEstado(codigo: string): string {
    const m: Record<string, string> = {
      pendiente: "blue-grey",
      en_revision: "blue",
      confirmada: "teal",
      enviada_gesden: "purple",
      insertada_gesden: "green",
      fallida_gesden: "orange",
      conflicto: "red",
      cancelada: "grey",
      rechazada: "red darken-3",
      expirada: "grey darken-1",
      cancelacion_pendiente_gesden: "deep-orange darken-1",
      reagendado_pendiente_gesden: "amber darken-2",
    };
    return m[codigo] || "grey";
  }

  public formatFecha(v: string): string {
    if (!v) { return "-"; }
    const d = new Date(v);
    if (isNaN(d.getTime())) { return v; }
    const p = (n: number) => n < 10 ? "0" + n : "" + n;
    return p(d.getDate()) + "/" + p(d.getMonth() + 1) + "/" + d.getFullYear() + " " + p(d.getHours()) + ":" + p(d.getMinutes());
  }

  public formatFechaCorta(iso: string): string {
    const parts = iso.split("-");
    if (parts.length !== 3) { return iso; }
    return parts[2] + "/" + parts[1] + "/" + parts[0];
  }

  public formatHora(v: string): string {
    const d = new Date(v);
    if (isNaN(d.getTime())) { return v; }
    const p = (n: number) => n < 10 ? "0" + n : "" + n;
    return p(d.getHours()) + ":" + p(d.getMinutes());
  }

  public formatLocalDateTime(d: Date): string {
    const p = (n: number) => n < 10 ? "0" + n : "" + n;
    return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()) + "T" + p(d.getHours()) + ":" + p(d.getMinutes()) + ":00";
  }

  public pretty(v: any): string {
    try { return JSON.stringify(v, null, 2); } catch (e) { return String(v); }
  }
}
